"use client";

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import CartSidebar from '../components/CartSidebar';

export default function CarrinhoPage() {
  const router = useRouter();
  const [usuario, setUsuario] = useState<any>(null);
  const [eventos, setEventos] = useState<any[]>([]);
  const [carrinho, setCarrinho] = useState<any[]>([]);
  const [montado, setMontado] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    setMontado(true);
    const userStr = localStorage.getItem('usuario');
    if (userStr) setUsuario(JSON.parse(userStr));

    const cartStr = localStorage.getItem('carrinho');
    if (cartStr) {
      try {
        setCarrinho(JSON.parse(cartStr));
      } catch (e) { }
    }

    fetch('https://api.arfainfo.com.br/api/eventos')
      .then(res => res.json())
      .then(data => {
        if (data.sucesso) setEventos(data.dados);
      })
      .catch(err => console.error("Erro ao buscar eventos:", err));
  }, []);

  const atualizarQuantidade = (index: number, novaQtd: number) => {
    if (novaQtd < 1) return;
    const novoCarrinho = [...carrinho];
    const item = novoCarrinho[index];
    let qtdEstoque = item.quantidade_estoque || 0;
    
    if (item.variacoes) {
      try {
        const obj = JSON.parse(item.variacoes);
        if (obj.estoque && item.variacoesSelecionadas && obj.propriedades) {
          const keyParts: string[] = [];
          obj.propriedades.forEach((p: any) => {
            if (item.variacoesSelecionadas[p.nome]) {
              keyParts.push(item.variacoesSelecionadas[p.nome]);
            }
          });
          const key = keyParts.join('|');
          if (obj.estoque[key] !== undefined) {
            qtdEstoque = obj.estoque[key];
          }
        }
      } catch(e) {}
    }
    
    if (novaQtd > (qtdEstoque || 99)) return;
    novoCarrinho[index].quantidade = novaQtd;
    setCarrinho(novoCarrinho);
    localStorage.setItem('carrinho', JSON.stringify(novoCarrinho));
  };

  const removerItem = (index: number) => {
    const novoCarrinho = carrinho.filter((_, i) => i !== index);
    setCarrinho(novoCarrinho);
    localStorage.setItem('carrinho', JSON.stringify(novoCarrinho));
  };

  const proximoEvento = eventos.length > 0 ? eventos[0] : null;
  let topbarTexto = 'BRASIL X HAITI | FESTA JUNINA | 19/06 | 18H';
  if (proximoEvento) {
    const dataFormated = new Date(proximoEvento.data_evento).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    topbarTexto = `${proximoEvento.titulo.toUpperCase()} | ${proximoEvento.tipo.toUpperCase()} | ${dataFormated}`;
  }

  const total = carrinho.reduce((acc, item) => acc + (parseFloat(item.preco) * item.quantidade), 0);
  const qtdCarrinho = carrinho.reduce((acc, item) => acc + item.quantidade, 0);

  if (!montado) return null;

  return (
    <div className="cgt-root font-sans text-[#6b1122] flex flex-col min-h-screen">
      <link href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Montserrat:ital,wght@0,400;0,600;0,700;0,800;0,900;1,400;1,800&display=swap" rel="stylesheet" />
      <style dangerouslySetInnerHTML={{
        __html: `
        .cgt-root { 
          min-height: 100vh; 
          font-family: 'Montserrat', sans-serif; 
          background-color: #e3e2de; 
          background-image: url('https://www.transparenttextures.com/patterns/concrete-wall.png'); 
          color: #6b1122;
        }
        .cgt-container { max-width: 1200px; margin-left: auto; margin-right: auto; padding-left: 20px; padding-right: 20px; }
        .cgt-title-font { font-family: 'Bebas Neue', 'Impact', sans-serif; letter-spacing: 0.02em; }
        
        /* ── TOPBAR (PRETA) ── */
        .cgt-topbar { background-color: #6b1122; color: #fff; padding: 10px 24px; display: flex; align-items: center; justify-content: space-between; font-size: 0.65rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; z-index: 60; position: relative; }
        .cgt-topbar-left { display: flex; align-items: center; gap: 8px; }
        .cgt-topbar-dot { color: #00c96e; font-size: 1rem; line-height: 0; margin-top: -2px; }
        .cgt-topbar-event { color: #00c96e; font-weight: 900; }
        .cgt-topbar-right { display: flex; align-items: center; gap: 24px; }
        .cgt-socials { display: flex; gap: 14px; align-items: center; }
        .cgt-socials a { color: #fff; text-decoration: none; display: flex; align-items: center; opacity: 0.8; transition: opacity 0.2s; }
        .cgt-socials a:hover { opacity: 1; color: #00c96e; }
        .cgt-area-btn { border: 1px solid #444; padding: 6px 14px; color: #fff; text-decoration: none; display: flex; align-items: center; gap: 6px; font-weight: 700; transition: 0.2s; }
        .cgt-area-btn:hover { background: #fff; color: #6b1122; }

        /* ── DIVISORES DE SEÇÃO ORNAMENTADOS ◆ ── */
        .cgt-section-header { display: flex; align-items: center; justify-content: center; gap: 20px; margin-bottom: 30px; }
        .cgt-section-line { height: 1px; background: #c2b59b; flex: 1; max-width: 300px; position: relative; }
        .cgt-section-line::after { content: '◆'; position: absolute; top: -7px; color: #c2b59b; font-size: 10px; }
        .cgt-section-line.left::after { right: 0; }
        .cgt-section-line.right::after { left: 0; }
        .cgt-section-title { font-size: 1.2rem; font-weight: 800; color: #6b1122; text-transform: uppercase; letter-spacing: 0.1em; }

        .cgt-header { background: rgba(255,255,255,0.96); backdrop-filter: blur(5px); border-bottom: 1px solid #dcdcdc; position: sticky; top: 0; z-index: 50; box-shadow: 0 2px 10px rgba(0,0,0,0.02); }
        .cgt-header-inner { display: flex; justify-content: space-between; align-items: center; padding-top: 12px; padding-bottom: 12px; }
        .cgt-logo { display: flex; align-items: center; gap: 2px; text-decoration: none; }
        .cgt-logo-text { display: flex; flex-direction: column; line-height: 1; margin-top: 2px; }
        .cgt-logo-text-1 { font-size: 0.55rem; font-weight: 700; letter-spacing: 0.15em; color: #555; }
        .cgt-logo-text-2 { font-size: 1.3rem; font-weight: 900; color: #6b1122; letter-spacing: 0em; margin: 1px 0; }
        .cgt-logo-text-3 { font-size: 0.65rem; font-weight: 800; letter-spacing: 0.2em; color: #6b1122; }

        .cgt-nav { display: flex; gap: 28px; align-items: center; }
        .cgt-nav a { font-size: 0.72rem; font-weight: 800; color: #6b1122; text-transform: uppercase; text-decoration: none; letter-spacing: 0.05em; position: relative; padding-bottom: 4px; }
        .cgt-nav a.active { color: #006437; }
        .cgt-nav a.active::after { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: #006437; }
        .cgt-nav a:hover { color: #006437; }

        /* menu mobile */
        #cgt-menu-toggle { display: none; }
        .cgt-hamburger { display: none; cursor: pointer; color: #6b1122; padding: 4px; }
        .cgt-mobile-actions { display: none; }
        @media (max-width: 992px) {
          .cgt-mobile-actions { display: flex; align-items: center; gap: 16px; position: relative; z-index: 60; }
          .cgt-socials-mobile { display: flex; align-items: center; gap: 12px; }
          .cgt-socials-mobile a { color: #6b1122; display: flex; align-items: center; opacity: 0.8; transition: 0.2s; }
          .cgt-socials-mobile a:hover { opacity: 1; color: #00c96e; }
          .cgt-hamburger { display: block; position: relative; z-index: 60; }
          .cgt-nav { display: none; flex-direction: column; position: absolute; top: 100%; left: 0; width: 100%; background-color: #fff; padding: 24px; gap: 16px; box-shadow: 0 8px 32px rgba(0,0,0,0.1); border-top: 1px solid #eee; z-index: 50; }
          #cgt-menu-toggle:checked ~ .cgt-nav { display: flex; }
          .cgt-nav a { width: 100%; text-align: center; padding: 12px 0; border-bottom: 1px solid #f0f0f0; }
        }

        .cgt-social-box-pills { display: flex; gap: 10px; }
        .cgt-social-pill { width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; text-decoration: none; transition: 0.2s; }
        .cgt-social-pill:hover { transform: translateY(-2px); filter: brightness(1.2); }

        /* ── LOWER CTA ── */
        .cgt-lower { padding: 60px 0; background: linear-gradient(to right, rgba(227,226,222,0.92), rgba(227,226,222,0.92)), url('https://images.unsplash.com/photo-1522778119026-d647f0596c20?auto=format&fit=crop&w=1000&q=80') center/cover; border-top: 1px solid #d5d5d5; border-bottom: 1px solid #d5d5d5; margin-bottom: 20px; }
        .cgt-lower-inner { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 30px; align-items: stretch; }
        .cgt-lower-left { display: flex; flex-direction: column; justify-content: center; }
        .cgt-lower-left h3 { font-size: 2.2rem; color: #6b1122; line-height: 1.1; margin: 0 0 10px 0; }
        .cgt-lower-left p { font-size: 1rem; font-weight: 800; color: #006437; text-transform: uppercase; letter-spacing: 0.05em; margin: 0; }
        .cgt-lower-card { background: #fdfdfd; padding: 24px; border-radius: 4px; box-shadow: 0 10px 25px rgba(0,0,0,0.04); border: 1px solid #ddd; display: flex; flex-direction: column; }
        .cgt-lower-card h4 { font-size: 1.5rem; margin: 0 0 6px 0; color: #6b1122; }
        .cgt-lower-card p { font-size: 0.75rem; color: #555; font-weight: 600; margin: 0 0 16px 0; flex-grow: 1; }
        .cgt-btn-block { display: flex; justify-content: space-between; align-items: center; background: #006437; color: #fff; padding: 14px 20px; font-weight: 800; font-size: 0.85rem; text-transform: uppercase; text-decoration: none; border-radius: 2px; transition: 0.2s; }
        .cgt-btn-block:hover { background: #004d2a; }

        /* ── FOOTER ── */
        .cgt-footer { padding: 40px 0; font-size: 0.75rem; color: #555; }
        .cgt-footer-inner { display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #ccc; padding-top: 25px; }
        .cgt-footer-logo { display: flex; align-items: center; gap: 2px; }
        .cgt-footer-brand { font-weight: 900; font-size: 0.95rem; color: #6b1122; letter-spacing: 0.02em; line-height: 1.2; margin-top: 2px; }
        @media (max-width: 992px) { .cgt-footer-brand { margin-top: 0; } }
        .cgt-footer-brand span { display: block; font-size: 0.55rem; color: #777; letter-spacing: 0.1em; }
        .cgt-footer-links { display: flex; gap: 40px; }
        .cgt-footer-col p { font-size: 0.6rem; font-weight: 800; color: #888; text-transform: uppercase; margin: 0 0 4px 0; }
        .cgt-footer-col a, .cgt-footer-col span { color: #6b1122; font-weight: 700; text-decoration: none; font-size: 0.8rem; }
        .cgt-footer-copy { text-align: right; font-size: 0.65rem; font-weight: 700; color: #777; text-transform: uppercase; letter-spacing: 0.05em; }
        @media (max-width: 992px) { 
          .cgt-footer-inner { flex-direction: column; gap: 24px; text-align: center; } 
          .cgt-lower-inner { grid-template-columns: 1fr; text-align: center; }
          .cgt-social-box-pills { justify-content: center; }
          .cgt-footer-brand { margin-top: 0; }
        }
        @media (max-width: 768px) {
          .cgt-topbar { flex-direction: row; justify-content: space-between; padding: 10px 16px; font-size: 0.65rem; gap: 12px; align-items: center; }
          .cgt-socials { display: none; }
          .cgt-topbar-left { white-space: normal; flex: 1; line-height: 1.4; display: block; }
          .cgt-topbar-dot { display: inline-block; margin-right: 4px; margin-top: 0; }
          .cgt-area-btn { padding: 6px 12px; font-size: 0.65rem; white-space: nowrap; flex-shrink: 0; align-self: stretch; display: flex; align-items: center; justify-content: center; }
        }
      `}} />

      {/* ─── 1. TOPBAR ────────────────────────────────────────── */}
      <div className="cgt-topbar">
        <div className="cgt-topbar-left">
          <span className="cgt-topbar-dot">●</span>
          <span>PRÓXIMO EVENTO: <span className="cgt-topbar-event">{topbarTexto}</span></span>
        </div>
        <div className="cgt-topbar-right hidden md:flex">
          <div className="cgt-socials">
            <a href="https://www.instagram.com/casaguerreirotricolor/" target="_blank" rel="noopener noreferrer">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
            </a>
            <a href="https://www.youtube.com/@casaguerreirotricolor" target="_blank" rel="noopener noreferrer">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
            </a>
            <a href="https://wa.me/5521996907307" target="_blank" rel="noopener noreferrer">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" /></svg>
            </a>
          </div>
          {usuario ? (
            <span className="cgt-area-btn opacity-80 cursor-default hover:bg-transparent hover:text-white border-transparent bg-transparent">
              <svg width="11" height="11" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
              {usuario.nome.split(' ')[0]}
            </span>
          ) : (
            <a href="/login" className="cgt-area-btn">
              <svg width="11" height="11" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
              ÁREA DO GUERREIRO
            </a>
          )}
        </div>
      </div>

      {/* HEADER OFICIAL */}
      <header className="cgt-header">
        <div className="cgt-container cgt-header-inner">
          <a href="/" className="cgt-logo">
            <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Casa do Guerreiro Tricolor" style={{ width: '44px', height: '44px', objectFit: 'contain' }} />
            <div className="cgt-logo-text">
              <span className="cgt-logo-text-1">Casa do</span>
              <span className="cgt-logo-text-2 cgt-title-font">GUERREIRO</span>
              <span className="cgt-logo-text-3">Tricolor</span>
            </div>
          </a>

          <input type="checkbox" id="cgt-menu-toggle" />
          <div className="cgt-mobile-actions">
            <div className="cgt-socials-mobile">
              <a href="https://www.instagram.com/casaguerreirotricolor/" target="_blank" rel="noopener noreferrer">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
              </a>
              <a href="https://www.youtube.com/@casaguerreirotricolor" target="_blank" rel="noopener noreferrer">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
              </a>
              <a href="https://wa.me/5521996907307" target="_blank" rel="noopener noreferrer">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" /></svg>
              </a>
            </div>
            <label htmlFor="cgt-menu-toggle" className="cgt-hamburger">
              <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </label>
          </div>

          <nav className="cgt-nav">
            <a href="/" suppressHydrationWarning>INÍCIO</a>
            <a href="/#historia" suppressHydrationWarning>A CASA</a>
            <a href="/#planos" suppressHydrationWarning>SÓCIO</a>
            <a href="/#eventos" suppressHydrationWarning>EVENTOS</a>
            <a href="/noticias" suppressHydrationWarning>NOTÍCIAS</a>
            <a href="/podcasts" suppressHydrationWarning>PODCASTS</a>
            <a href="/loja" className="active" suppressHydrationWarning>LOJA</a>
            <a href="/painel" suppressHydrationWarning>ÁREA DO GUERREIRO</a>
            <a href="#" onClick={(e) => { e.preventDefault(); setIsCartOpen(true); }} suppressHydrationWarning className="relative flex items-center justify-center bg-[#f5f5f5] w-8 h-8 rounded-full hover:bg-[#e0e0e0] transition text-[#6b1122] ml-2">
              <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              {qtdCarrinho > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#00c96e] text-white text-[9px] font-black w-4 h-4 flex items-center justify-center rounded-full shadow-sm">
                  {qtdCarrinho}
                </span>
              )}
            </a>
            {usuario && (
              <button onClick={() => { localStorage.removeItem('usuario'); setUsuario(null); router.push('/login'); }} className="bg-[#8A1538] text-white px-4 py-2 rounded font-bold text-[10px] hover:bg-[#5a0c23] transition uppercase tracking-widest shadow-sm ml-2 md:ml-0">
                Sair
              </button>
            )}
          </nav>
        </div>
      </header>

      {/* ─── 3. CARRINHO ───────────────────────────── */}
      <main className="cgt-container pt-10 pb-16 flex-grow w-full">
        <div className="cgt-section-header mt-4">
          <div className="cgt-section-line left"></div>
          <div className="cgt-section-title">MEU CARRINHO</div>
          <div className="cgt-section-line right"></div>
        </div>

        {carrinho.length === 0 ? (
          <div className="bg-white rounded-xl shadow-sm border border-[#ddd] p-12 text-center mt-8">
            <svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="mx-auto text-gray-300 mb-4"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
            <h2 className="text-[#6b1122] font-black text-xl mb-2">Seu carrinho está vazio</h2>
            <p className="text-gray-500 mb-6">Explore a Loja do Guerreiro e encontre produtos exclusivos.</p>
            <button
              onClick={() => router.push('/loja')}
              className="bg-[#006437] text-white font-bold uppercase text-xs px-6 py-3 rounded hover:bg-[#004d2a] transition shadow-sm"
            >
              Ir para a Loja
            </button>
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row gap-8 mt-8">
            <div className="lg:w-2/3">
              <div className="bg-white rounded-xl shadow-sm border border-[#ddd] overflow-hidden">
                <div className="hidden md:grid grid-cols-12 gap-4 p-4 border-b border-[#eee] bg-gray-50 font-bold text-xs text-gray-500 uppercase tracking-wider">
                  <div className="col-span-6">Produto</div>
                  <div className="col-span-2 text-center">Preço</div>
                  <div className="col-span-2 text-center">Quantidade</div>
                  <div className="col-span-2 text-right">Subtotal</div>
                </div>

                {carrinho.map((item, index) => (
                  <div key={index} className="grid grid-cols-1 md:grid-cols-12 gap-4 p-4 border-b border-[#eee] items-center">
                    <div className="col-span-1 md:col-span-6 flex items-center gap-4">
                      <button
                        onClick={() => removerItem(index)}
                        className="text-gray-400 hover:text-red-600 transition"
                        title="Remover"
                      >
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                      </button>
                      <img src={item.imagem_url || 'https://via.placeholder.com/100x100'} alt={item.nome} className="w-16 h-16 object-cover rounded shadow-sm border border-gray-100" />
                      <div>
                        <h4 className="font-bold text-[#6b1122]">{item.nome}</h4>
                        {item.variacoesSelecionadas && Object.keys(item.variacoesSelecionadas).length > 0 && (
                          <p className="text-[11px] text-gray-500 mt-1 font-bold">
                            {Object.entries(item.variacoesSelecionadas).map(([k, v]) => `${k}: ${v}`).join(' | ')}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="col-span-1 md:col-span-2 text-left md:text-center font-semibold text-gray-600">
                      <span className="md:hidden text-xs text-gray-400 uppercase mr-2">Preço:</span>
                      R$ {Number(item.preco).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </div>

                    <div className="col-span-1 md:col-span-2 flex justify-start md:justify-center">
                      <span className="md:hidden text-xs text-gray-400 uppercase mr-2 self-center">Qtd:</span>
                      <div className="flex items-center border border-gray-300 rounded overflow-hidden h-8">
                        <button
                          onClick={() => atualizarQuantidade(index, item.quantidade - 1)}
                          className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold transition w-8 text-center"
                        >
                          -
                        </button>
                        <input
                          type="text"
                          value={item.quantidade}
                          readOnly
                          className="w-10 text-center font-bold text-[#6b1122] bg-white border-x border-gray-300 h-full text-sm"
                        />
                        <button
                          onClick={() => atualizarQuantidade(index, item.quantidade + 1)}
                          className="px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold transition w-8 text-center"
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <div className="col-span-1 md:col-span-2 text-left md:text-right font-black text-[#006437]">
                      <span className="md:hidden text-xs text-gray-400 uppercase mr-2">Subtotal:</span>
                      R$ {(Number(item.preco) * item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:w-1/3">
              <div className="bg-white rounded-xl shadow-sm border border-[#ddd] p-6 sticky top-24">
                <h3 className="font-black text-[#6b1122] text-lg uppercase mb-4 border-b border-[#eee] pb-4">Resumo do Pedido</h3>

                <div className="flex justify-between items-center mb-4 text-gray-600">
                  <span>Subtotal ({carrinho.reduce((a, c) => a + c.quantidade, 0)} itens)</span>
                  <span className="font-semibold">R$ {total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                </div>

                <div className="flex justify-between items-center mb-6 text-gray-600">
                  <span>Frete</span>
                  <span className="text-sm italic">Calculado no próximo passo</span>
                </div>

                <div className="border-t border-[#eee] pt-4 mb-6 flex justify-between items-center">
                  <span className="font-black text-gray-800 uppercase">Total Estimado</span>
                  <span className="font-black text-2xl text-[#006437]">R$ {total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                </div>

                <button
                  onClick={() => {
                    if (usuario) {
                      router.push('/pagamento');
                    } else {
                      router.push('/cadastro?redirect=/pagamento');
                    }
                  }}
                  className="w-full bg-[#006437] text-white font-black uppercase tracking-widest text-sm py-4 rounded-lg hover:bg-[#004d2a] transition-all shadow-sm"
                >
                  Finalizar Compra
                </button>

                <button
                  onClick={() => router.push('/loja')}
                  className="w-full mt-3 bg-white text-[#8A1538] border border-[#8A1538] font-bold uppercase tracking-wider text-xs py-3 rounded-lg hover:bg-gray-50 transition-all"
                >
                  Continuar Comprando
                </button>
              </div>
            </div>
          </div>
        )}
      </main>

      {/* ─── 10. LOWER BANNER ────────────────────────────────── */}
      <section className="cgt-lower">
        <div className="cgt-container cgt-lower-inner">
          <div className="cgt-lower-left">
            <h3 className="cgt-title-font">MAIS QUE UMA TORCIDA.<br />UMA FAMÍLIA.<br />UMA CASA.</h3>
            <p>GUERREIROS PARA SEMPRE!</p>
          </div>
          <div className="cgt-lower-card">
            <h4 className="cgt-title-font">ÁREA DO GUERREIRO</h4>
            <p>Acesse sua conta e aproveite<br />todos os benefícios exclusivos.</p>
            <a href="/login" className="cgt-btn-block">
              ACESSAR AGORA <span>›</span>
            </a>
          </div>
          {/* Card de Redes Sociais Integrado */}
          <div className="cgt-lower-card">
            <h4 className="cgt-title-font">SIGA NOSSAS REDES</h4>
            <p>@casaguerreirotricolor<br />Acompanhe as novidades e eventos.</p>
            <div className="cgt-social-box-pills">
              <a href="https://www.instagram.com/casaguerreirotricolor/" className="cgt-social-pill" style={{ backgroundColor: '#E1306C' }}>
                <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
              </a>
              <a href="https://www.youtube.com/@casaguerreirotricolor" className="cgt-social-pill" style={{ backgroundColor: '#FF0000' }}>
                <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
              </a>
              <a href="https://wa.me/5521996907307" className="cgt-social-pill" style={{ backgroundColor: '#25D366' }}>
                <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" /></svg>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61576382574287" className="cgt-social-pill" style={{ backgroundColor: '#1877F2' }}>
                <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" /></svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ─── FOOTER ───────────────────────────────────────── */}
      <footer className="cgt-footer mt-auto">
        <div className="cgt-container">
          <div className="cgt-footer-inner">
            <div className="cgt-footer-logo">
              <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Casa do Guerreiro Tricolor" style={{ width: '36px', height: '36px', objectFit: 'contain' }} />
              <div className="cgt-footer-brand cgt-title-font">
                <span>CASA DO</span> GUERREIRO TRICOLOR
              </div>
            </div>

            <div className="cgt-footer-links">
              <div className="cgt-footer-col">
                <p>FALE CONOSCO</p>
                <a href="https://wa.me/5521996907307">(21) 99690-7307</a>
              </div>
              <div className="cgt-footer-col">
                <p>ONDE ESTAMOS</p>
                <a href="https://maps.app.goo.gl/z59FvHbW75VRD7xt9" target="_blank" rel="noopener noreferrer">Av. Luís de Matos, 30 - Luz, Nova Iguaçu - RJ, 26255-510</a>
              </div>
            </div>

            <div className="cgt-footer-copy">
              © 2026 Casa do Guerreiro Tricolor.<br />Todos os direitos reservados.
            </div>
          </div>
        </div>
      </footer>
      <CartSidebar 
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        carrinho={carrinho}
        atualizarQuantidade={atualizarQuantidade}
        removerItem={removerItem}
      />
    </div>
  );
}
